module.exports = __webpack_public_path__ + "static/media/speedometer.49fa6923.svg";